import { Box, Button, Stack, Typography } from '@packages/shared';
import { Basket32 } from '@packages/themes/icons';
import { useIntl, defineMessages } from 'react-intl';
import type { SxProps } from '@mui/material';
import { LoginDialogComposed } from '@packages/modules';

const commonButtonSize: SxProps = {
  width: '21.938rem',
  maxWidth: '100%',
};
const messages = defineMessages({
  emptyBasketHeadline: {
    id: 'BasketEmpty.Headline',
    defaultMessage: 'Dein Warenkorb ist leer',
  },
  loggedInInfoText: {
    id: 'BasketEmpty.LoggedIn.InfoText',
    defaultMessage:
      'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
  loggedOutInfoText: {
    id: 'BasketEmpty.LoggedOut.InfoText',
    defaultMessage:
      'Du vermisst Artikel, die du bereits in den Warenkorb gelegt hast? Dann melde dich bitte an, um deine gespeicherten Artikel zu sehen.',
  },
  emptyBasketButton: {
    id: 'BasketEmpty.GoToShop',
    defaultMessage: 'Weiter im Shop',
  },
  loginBasketButton: {
    id: 'BasketEmpty.Login',
    defaultMessage: 'Anmelden',
  },
});
export const BasketEmpty: React.FC<{ loggedIn?: boolean }> = ({ loggedIn }) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Box sx={{ maxWidth: '49.625rem' }} data-testid="basket-empty-wrapper">
        <Stack
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            textAlign: 'center',
            p: {
              xs: '1.25rem 0.75rem 1.75rem',
              md: '1.25rem 1.75rem 3rem',
            },
            mb: 2.5,
            bgcolor: 'grey.light',
          }}
        >
          <Basket32 sx={{ fontSize: '5rem', color: 'grey.main' }} />
          <Typography typography={{ xs: 'h4', md: 'h3' }} sx={{ mt: 2.5, mb: { xs: 1, md: 1.5 } }}>
            {formatMessage(messages.emptyBasketHeadline)}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mb: {
                xs: 3.5,
                md: '3rem',
              },
            }}
          >
            {loggedIn && formatMessage(messages.loggedInInfoText)}
            {!loggedIn && formatMessage(messages.loggedOutInfoText)}
          </Typography>
          <Stack
            direction={{ xs: 'column-reverse', md: 'row' }}
            justifyContent="space-around"
            spacing={1.5}
            sx={{
              maxWidth: '100%',
              width: {
                xs: 'auto',
                md: '100%',
              },
            }}
          >
            <Button
              color={loggedIn ? 'primary' : undefined}
              size="large"
              href="/"
              sx={commonButtonSize}
            >
              {formatMessage(messages.emptyBasketButton)}
            </Button>
            {!loggedIn && (
              <LoginDialogComposed>
                {(openDialog) => (
                  <Button onClick={openDialog} size="large" color="primary" sx={commonButtonSize}>
                    {formatMessage(messages.loginBasketButton)}
                  </Button>
                )}
              </LoginDialogComposed>
            )}
          </Stack>
        </Stack>
        {/* TODO: implement direct order}
          {directOrder && <DirectOrder mode="Basket" isEmptyBasket />}
          { */}
      </Box>
      {/* TODO: implement new RDE}
      <SliderWrapper>
        <WishListProvider>
          <RecoSlider
            preferHeadline
            rdeParams={{
              rdeType: 'prudsysBasket',
              recoApi,
              requestParams: {
                productIds: [],
              },
              trackingProps: { pageTemplate: 'basket', sourceCategoryId: '' },
              RecoSliderBaseProps: {
                SliderSettingsProps: {
                  headline: formatMessage(messages.productRecSliderHeadline),
                },
              },
            }}
          />
        </WishListProvider>
      </SliderWrapper>
      { */}
    </>
  );
};
